import { createContext } from "react";
import { OmniboxSearchResult } from "../../generated/graphql";

type SearchContextType = {
  isSearching: boolean;
  setIsSearching: (isSearching: boolean) => void;
  results: OmniboxSearchResult[];
  setResults: (results: OmniboxSearchResult[]) => void;
  query: string;
  setQuery: (query: string) => void;
  resetSearch: () => void;
  loadingSearch: boolean;
  setLoadingSearch: (loadingSearch: boolean) => void;
};
export const SearchContext = createContext<SearchContextType>({
  isSearching: false,
  setIsSearching: () => {},
  results: [],
  setResults: () => {},
  query: "",
  setQuery: () => {},
  resetSearch: () => {},
  loadingSearch: false,
  setLoadingSearch: () => {},
});
